import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { CloseIcon } from "@icarius-icons";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";

const StyledDialog = withStyles({
  paper: {
    minWidth: "90%",
  },
})(Dialog);

const GridDialog = (props) => {

  const {
    open,
    data,
    name,
    handleClose,
  } = props;

  return (
    <StyledDialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      fullWidth={true}
      maxWidth={"md"}>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
        {getLocalizedString("benefitsUsageDetail")}
      </DialogTitle>
      <DialogContent>
        <CommonPage
          gridTitle={name}
          columnDefPage={"benefitRecognitionPlansDetail"}
          rowData={data}
          gridHeight={'70vh'}
          hasExpand
          hasSelectAll
          ignoreProcessesbyPath
        />
      </DialogContent>      
    </StyledDialog>
  );
}

export default GridDialog;